<template lang="pug">
#order-modal.modal-card
  header.modal-card-head
    p.modal-card-title Order {{ order.number }} Receipt
  b-table(
    :data="order.items"
  )
    template(slot-scope="props")
      b-table-column(label="Item") {{ props.row.label }}
      b-table-column(label="Qty") 1
      b-table-column(label="Amount" numeric) {{ props.row.amount | cents }}
    template(slot="footer")
      th(colspan="2")
      th {{ order.amount | cents }}

  footer.modal-card-foot
    a.button(
      v-if="order.stripe_transaction_id"
      :href="stripeLink"
      target="_blank"
    ) Manage on Stripe
    //- a.button.is-danger(@click="confirmRefund") Refund
    //- a.button.is-light(type="button" @click="$parent.close()") Cancel
    //- button.button.is-light
    //-   b-icon(icon="email-outline")
    //-   span Resend Receipt
</template>

<script>
import { mapGetters } from 'vuex';
import * as getters from '@/store/types/getters';

export default {
  name: 'order-modal',
  computed: {
    ...mapGetters({
      event: getters.GET_EVENT,
      order: getters.GET_ORDER,
    }),
    stripeLink() {
      return `https://dashboard.stripe.com/payments/${this.order.stripe_transaction_id}`;
    },
  },
  data() {
    return {};
  },
  methods: {
    confirmRefund() {},
  },
};
</script>

<style lang="scss">
#order-modal {
  .b-table {
    background-color: white;
    table.table {
      tr {
        td, th {
          &:first-child {
            padding-left: 20px;
          }
          &:last-child {
            padding-right: 20px;
          }
        }
      }
      tfoot {
        background-color: $white-ter;
        tr {
          th {
            font-weight: 500;
            font-size: 1.25rem;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderModal.vue